module.exports = __webpack_public_path__ + "img/PL08831.d44fdecc.png";